export default "__VITE_ASSET__BSF$O3TG__"